import React from "react";
import {URL_GENERAL, urlEnGeneral} from "../../_services/cart/tiendaHost";

/**
 * Lo que se ve en un subdominio que no es una tienda (o cuya tienda no esta habilitada). Va sin la
 * app alrededor: no hay tienda de la que mostrar nada, y el sitio general esta a un link.
 */
export function TiendaNoDisponible() {
    return (
        <div className="tiendaNoDisponible">
            <img src={process.env.PUBLIC_URL + "/images/isologo-original.png"} width="120" alt="DeAutopartes"/>
            <h1>Esta tienda no está disponible</h1>
            <p>La dirección no corresponde a ninguna tienda activa en este momento.</p>
            <a className="button" data-type="primary" href={urlEnGeneral("/")}>
                Ir a {URL_GENERAL.replace("https://", "")}
            </a>
        </div>
    );
}
